export enum CountryGroup {
    EUROPE = "EUROPE",
    ASIA = "ASIA",
    AFRICA = "AFRICA",
    NORTH_AMERICA = "NORTH_AMERICA",
    CENTRAL_AMERICA = "CENTRAL_AMERICA",
    SOUTH_AMERICA = "SOUTH_AMERICA",
    OCEANIA = "OCEANIA",
}

export namespace CountryGroup {
    export function displayName(type: CountryGroup): string {
        switch (type) {
            case CountryGroup.NORTH_AMERICA: return "North America";
            case CountryGroup.CENTRAL_AMERICA: return "Central America";
            case CountryGroup.SOUTH_AMERICA: return "South America";
            case CountryGroup.AFRICA: return "Africa";
            case CountryGroup.EUROPE: return "Europe";
            case CountryGroup.ASIA: return "Asia";
            case CountryGroup.OCEANIA: return "Oceania";
            default: return "Unknown";
        }
    }
}
